// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-formulario[data-v-0da070df] {\n  border-top: 0.75rem solid var(--primaryColor, #a82339);\n  border-left: 1rem solid #666666;\n  border-radius: 8px;\n  padding: 2em;\n  width: 100%;\n  max-width: 750px;\n  box-sizing: border-box;\n  box-shadow: 2px 2px 2px rgba(112, 117, 122, 0.4);\n}\n.ajustes[data-v-0da070df] {\n  color: #8a6d3b;\n  background-color: #fcf8e3;\n  border: 1px solid #faebcc;\n  border-radius: 4px;\n  overflow-wrap: anywhere;\n}", ""]);
// Exports
module.exports = exports;
